import React from 'react'
import { styled } from '@mui/material'

export const HeaderWrapper = styled('div')({
})


